import React from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { useL2DTheme } from '@europrocurement/flexy-components';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { TiersCommercial } from '@europrocurement/l2d-modules/providers/TiersProvider';
import { PeoplePreview } from '@europrocurement/l2d-modules/modules/Dossiers/components/liste';

type CommercialSectionProps = {
    commercial: TiersCommercial;
};

const CommercialSection: React.FunctionComponent<CommercialSectionProps> = function ({
    commercial,
}) {
    const { palette } = useL2DTheme();
    const { utilisateur } = commercial;
    const fullName = [utilisateur.prenom, utilisateur.nom].filter(Boolean).join(' ');
    const phone = utilisateur.portable || utilisateur.ligneDirecte;

    return (
        <Box>
            <Typography
                variant="caption"
                sx={{ fontWeight: 700, textTransform: 'uppercase', color: palette.text.secondary }}
            >
                Commercial principal
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1em',
                    mt: 1,
                    p: 1.5,
                    border: `1px solid ${palette.divider}`,
                    borderRadius: 1,
                    backgroundColor: palette.background.paper,
                }}
            >
                <PeoplePreview
                    firstName={utilisateur.prenom}
                    lastName={utilisateur.nom}
                    sx={{ margin: 0, width: 40, height: 40 }}
                    sxAvatar={{ width: 40, height: 40, borderRadius: '8px' }}
                    auth={false}
                />
                <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: '0.5em' }}>
                    <Typography
                        variant="body2"
                        sx={{ fontWeight: 600, color: palette.text.primary }}
                        noWrap
                    >
                        {fullName || 'Inconnu'}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: '0.5em', mt: 0.5 }}>
                        {utilisateur.email && (
                            <Tooltip title={utilisateur.email}>
                                <IconButton
                                    size="small"
                                    component="a"
                                    href={`mailto:${utilisateur.email}`}
                                    sx={{
                                        width: 28,
                                        height: 28,
                                        border: `1px solid ${palette.divider}`,
                                        color: palette.text.secondary,
                                    }}
                                >
                                    <FaOptionIcon
                                        icon={['fasl', 'envelope']}
                                        sx={{ fontSize: '12px' }}
                                    />
                                </IconButton>
                            </Tooltip>
                        )}
                        {phone && (
                            <Tooltip title={phone}>
                                <IconButton
                                    size="small"
                                    component="a"
                                    href={`tel:${phone}`}
                                    sx={{
                                        width: 28,
                                        height: 28,
                                        border: `1px solid ${palette.divider}`,
                                        color: palette.text.secondary,
                                    }}
                                >
                                    <FaOptionIcon
                                        icon={['fasl', 'phone']}
                                        sx={{ fontSize: '12px' }}
                                    />
                                </IconButton>
                            </Tooltip>
                        )}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default CommercialSection;
